import React from 'react';
import styles from './styles.module.scss';
import { Text as GlobalText } from 'components/typography/Text';

export const Text = ({ dark, intl, size }) => (
  <div className={styles.text}>
    <GlobalText
      dark={dark}
      underline
      size={size}
      intl={intl}
    />
  </div>
);
